// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3rUPa","label":"Section_label__3IlJp","contentWrap":"Section_contentWrap__IiW8d","footer":"Section_footer__268VB","footerInner":"Section_footerInner__3IhRt"};